export const FMS_NAV_ITEMS = [
  {
    key: 'home', to: { name: 'Home' }, selectedWhen: 'Home', label: 'Home', icon: 'IconHome', activeIcon: 'IconHomeActive',
  },
  {
    key: 'dashboard', to: { name: 'FmsDashboard' }, selectedWhen: 'FmsDashboard', label: 'Dashboard', icon: 'IconDashboard',
  },
  {
    key: 'report', to: { name: 'ReportWrapper' }, selectedWhen: 'ReportWrapper', labelActiveWhen: 'FmsReport', label: 'Report', icon: 'IconReport',
  },
  {
    key: 'weather',
    href: '/weather',
    selectedWhen: 'Weather',
    label: 'Weather',
    icon: 'IconWeather',
    requires: (vm) => vm.userAccess.weather?.includes('read'),
  },
  {
    key: 'event-log',
    to: { name: 'EventLog' },
    selectedWhen: 'EventLog',
    label: 'Event Log',
    icon: 'IconEventLog',
    requires: (vm) => vm.userAccess.log_event_event?.includes('read'),
  },
  {
    key: 'voyage', to: { name: 'Voyage' }, selectedWhen: 'Voyage', label: 'Voyage', icon: 'IconVoyage',
  },
];

export const BUNKERING_NAV_ITEMS = [
  {
    key: 'home',
    to: { name: 'BunkerDashboard' },
    selectedWhen: 'BunkerDashboard',
    label: 'Home',
    icon: 'IconHome',
    requires: (vm) => vm.canRead('master_bunker_log'),
  },
  {
    key: 'bunker-log',
    to: { name: 'BunkeringLog' },
    selectedWhen: 'BunkeringLog',
    label: 'Bunker Log',
    icon: 'IconBunkeringLog',
    requires: (vm) => vm.canRead('master_bunker_log'),
  },
  {
    key: 'rob',
    to: { name: 'RemainOnBoard' },
    selectedWhen: 'RemainOnBoard',
    label: 'Remain On Board',
    icon: 'IconROB',
    requires: (vm) => vm.canRead('master_rob_rob'),
  },
];
